import { TreeItem, TreeView } from "@mui/lab";
import { IconButton } from "@mui/material";
import React from "react";
import { MdChevronRight, MdEdit, MdExpandMore } from "react-icons/md";
import ThemeButton from "./ThemeButton";
import { useNavigate } from "react-router-dom";

function CurriculumContainer(props) {
  const { curriculum } = props;
  const navigate = useNavigate();
  return (
    <div className=" bg-secondary p-3 rounded-lg">
      <div className="font-bold flex items-center mb-2">
        <div className="flex-grow align-middle flex gap-2 items-center">
          {curriculum.name}{" "}
          <div className="text-sm  uppercase">({curriculum.type})</div>
        </div>

        <ThemeButton
          variant="text"
          onClick={() => {
            navigate("/dashboard/curriculum/edit/" + curriculum._id);
          }}
        >
          <MdEdit size={20} />
        </ThemeButton>
      </div>

      <TreeView
        defaultCollapseIcon={<MdExpandMore />}
        defaultExpandIcon={<MdChevronRight />}
      >
        {curriculum.modules.map((module, index) => {
          return (
            <TreeItem nodeId={module._id} key={index} label={module.name}>
              {module.topics.map((topic, index) => {
                return (
                  <TreeItem
                    nodeId={topic._id}
                    key={index}
                    label={topic.name + " (" + topic.type + ")"}
                  />
                );
              })}
            </TreeItem>
          );
        })}
      </TreeView>
    </div>
  );
}

export default CurriculumContainer;
